import React, { useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import { submitCredential } from "../../../../apis/Api";
import RouteConstant from "../../../../constants/routesContent.json";
import LoginConstants from "../../../../constants/contentFile.json";
import { useCookies } from "react-cookie";
import { validateUserCredentials } from "../../../../utils/service";

export const LoginCredentailsContext = createContext({});
export const LoginCredentailsContextProvider = ({ children }) => {
  const [userId, setUserID] = useState("");
  const [password, setPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies(["user"]);
  const [apiStatus, setApiStatus] = useState("");
  const loginContent = LoginConstants?.errorMessages;

  const loginCredentailsSubmit = async () => {
    const userData = {
      Supplier_Id: userId,
      Password: password,
    };
    const validateUser = validateUserCredentials(userId, password);

    if (validateUser === true) {
      setApiStatus("fetching");
      try {
        const submitCredentialData = await submitCredential(userData);
        if (submitCredentialData?.data?.statusCode === 200) {
          const token = submitCredentialData?.data["Access-Token"];
          const supplierId = submitCredentialData?.data["supplier_id"];
          const userId = submitCredentialData?.data["userId"];
          const isZonalHead = submitCredentialData?.data["is_zonal_head"];
          setCookie("xAccessToken", token, { path: "/" });
          setCookie("supplierId", supplierId, { path: "/" });
          setCookie("userId", userId, { path: "/" });
          setCookie("isZonalHead", isZonalHead, { path: "/" });
          navigate(RouteConstant.ORDER_DETAILS);
        }
      } catch (error) {
        if (error?.response?.data?.statusCode === 400) {
          const errorMessage = error.response.data.statusMessage;
          setAlertMessage(errorMessage);
          setShowAlert(true);
        } else {
          setAlertMessage(loginContent.somethingWrong);
          setShowAlert(true);
        }
      }
      setApiStatus("completed");
    } else {
      setShowAlert(true);
      setAlertMessage(validateUser);
    }
  };

  const providerValue = {
    setPassword,
    setUserID,
    loginCredentailsSubmit,
    userId,
    password,
    showAlert,
    setShowAlert,
    alertMessage,
    apiStatus,
  };
  return (
    <LoginCredentailsContext.Provider value={providerValue}>
      {children}
    </LoginCredentailsContext.Provider>
  );
};
